export function parseFilenameByFormat(
  filename: string,
  regex: RegExp,
  formatString: string,
) {
  const match = filename.match(regex)

  if (!match) {
    // eslint-disable-next-line no-console
    console.error('Filename does not match the format', filename, formatString)
    return null
  }

  // Extract the placeholder names from the format string
  const placeholderPattern = /\{(grade|unit|lesson|name|module|character)\}/g
  const formatParts = [...formatString.matchAll(placeholderPattern)].map(
    (m) => m[1],
  )

  const parsedData: { [key: string]: string } = {}
  formatParts.forEach((part, index) => {
    parsedData[part] = match[index + 1]
  })

  return parsedData
}
